
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
// import { area, length } from '@turf/turf';
import {
  area,
  length,
  polygon as turfPolygon,
  lineString
} from '@turf/turf';
import { mappls } from 'mappls-web-maps';
import { getData, postData, putData, deleteData } from '../../../../Services/Fetchnodeservices';

// ─── Leaflet + Geoman loader ──────────────────────────────────────────
let L = null;
let libsLoaded = false;

function loadLeaflet() {
  if (libsLoaded && L) return Promise.resolve(L);
  return new Promise((resolve) => {
    const ensureCss = (href) => {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    };
    ensureCss('https://unpkg.com/leaflet@1.9.4/dist/leaflet.css');
    ensureCss('https://unpkg.com/@geoman-io/leaflet-geoman-free@2.18.3/dist/leaflet-geoman.css');

    const loadGeoman = () => {
      L = window.L;
      if (L.PM) { libsLoaded = true; resolve(L); return; }
      const g = document.createElement('script');
      g.src = 'https://unpkg.com/@geoman-io/leaflet-geoman-free@2.18.3/dist/leaflet-geoman.min.js';
      g.onload = () => { libsLoaded = true; resolve(L); };
      document.head.appendChild(g);
    };

    if (window.L) { loadGeoman(); return; }
    const s = document.createElement('script');
    s.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    s.onload = loadGeoman;
    document.head.appendChild(s);
  });
}

// ─── Helpers ──────────────────────────────────────────────────────────
function polyToCoords(layer) {
  const latlngs = layer.getLatLngs();
  const ring = Array.isArray(latlngs[0]) ? latlngs[0] : latlngs;
  const flat = Array.isArray(ring[0]) ? ring[0] : ring;
  return flat.map(p => ({ lat: p.lat, lng: p.lng }));
}

function circleToPolygonPoints(center, radiusKm, steps = 40) {
  const points = [];
  const R = 6371;
  const d = radiusKm / R;
  const lat1 = center.lat * Math.PI / 180;
  const lng1 = center.lng * Math.PI / 180;
  for (let i = 0; i <= steps; i++) {
    const brng = (i / steps) * 2 * Math.PI;
    const lat2 = Math.asin(Math.sin(lat1) * Math.cos(d) + Math.cos(lat1) * Math.sin(d) * Math.cos(brng));
    const lng2 = lng1 + Math.atan2(Math.sin(brng) * Math.sin(d) * Math.cos(lat1), Math.cos(d) - Math.sin(lat1) * Math.sin(lat2));
    points.push({ lat: lat2 * 180 / Math.PI, lng: lng2 * 180 / Math.PI });
  }
  return points;
}

function getPolygonCentroid(coords) {
  if (!coords || coords.length < 3) return null;
  let lat = 0, lng = 0;
  for (const p of coords) { lat += p.lat; lng += p.lng; }
  return { lat: lat / coords.length, lng: lng / coords.length };
}

// ─── Reverse geocoding ──────────────────────────────────────────────
async function getAddressFromCoords(lat, lng) {
  try {
    const url = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json&addressdetails=1&zoom=16`;
    const res = await fetch(url);
    const data = await res.json();
    if (data && data.address) {
      const addr = data.address;
      const parts = [];
      if (addr.neighbourhood || addr.suburb) parts.push(addr.neighbourhood || addr.suburb);
      if (addr.city || addr.town || addr.village) parts.push(addr.city || addr.town || addr.village);
      if (addr.state) parts.push(addr.state);
      if (addr.country) parts.push(addr.country);
      return parts.join(', ') || data.display_name || 'Unknown location';
    }
    return 'Unknown location';
  } catch {
    return 'Unknown location';
  }
}

// ─── City search with polygon ───────────────────────────────────────
// async function searchLocation(query) {
//   if (!query || query.length < 2) return [];
//   try {
//     const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&addressdetails=1&limit=5&countrycodes=in&polygon_geojson=1`;
//     const res = await fetch(url);
//     const data = await res.json();
//     return data.map(item => {
//       let polygon = null;
//       if (item.geojson && (item.geojson.type === 'Polygon' || item.geojson.type === 'MultiPolygon')) {
//         let coords;
//         if (item.geojson.type === 'MultiPolygon') {
//           coords = item.geojson.coordinates[0][0];
//         } else {
//           coords = item.geojson.coordinates[0];
//         }
//         polygon = coords.map(coord => ({
//           lat: coord[1],
//           lng: coord[0]
//         }));
//         // Simplify polygon to reduce points (optional)
//         // ─── Preserve accurate city boundary ────────────────────────────────
// // Small/medium boundaries are kept exactly as received.
// // Only extremely huge boundaries are reduced to protect browser performance.

// if (polygon.length > 2500) {

//   const step = Math.ceil(
//     polygon.length / 1800
//   );

//   const simplified = polygon.filter(
//     (_, index) => index % step === 0
//   );

//   // Always preserve the final original boundary point
//   const lastOriginal =
//     polygon[polygon.length - 1];

//   const lastSimplified =
//     simplified[simplified.length - 1];

//   if (
//     lastOriginal &&
//     lastSimplified &&
//     (
//       lastOriginal.lat !== lastSimplified.lat ||
//       lastOriginal.lng !== lastSimplified.lng
//     )
//   ) {
//     simplified.push(lastOriginal);
//   }

//   polygon = simplified;
// }
//       }
//      return {
//   name: item.display_name.split(',')[0] || 'Unknown',
//   lat: parseFloat(item.lat),
//   lng: parseFloat(item.lon),
//   display: item.display_name,
//   displayName: item.display_name,

//   // Important for correct city zoom
//   bbox: item.boundingbox || null,

//   polygon: polygon,
//   place_id: item.place_id
// };
//     });
//   } catch {
//     return [];
//   }
// }


// ─── Mappls-based City Search ──────────────────────────────────────
async function searchLocation(query) {
  if (!query || query.length < 2) return [];
  try {
    const MAPPLS_API_KEY = 'cnmdcjrbwcbzhkzekxgfrjtivauibmsicgdb';
    // Autosuggest API – returns places with geometry (polygon) and bounding box
    // const url = `https://autosuggest.mappls.com/v1/places?query=${encodeURIComponent(query)}&api_key=${MAPPLS_API_KEY}&limit=5`;
    const url = `https://autosuggest.mapmyindia.com/v1/places?query=${encodeURIComponent(query)}&api_key=${MAPPLS_API_KEY}&limit=5`;

    const res = await fetch(url);
    const data = await res.json();

    // Mappls response structure: { suggestions: [ { placeName, lat, lng, address, geometry, boundingBox, placeId } ] }
    return data.suggestions.map(item => {
      let polygon = null;
      // Check if geometry is available (Polygon)
      if (item.geometry && item.geometry.type === 'Polygon') {
        const coords = item.geometry.coordinates[0]; // array of [lng, lat]
        polygon = coords.map(coord => ({ lat: coord[1], lng: coord[0] }));
      }

      // Bounding box – Mappls sometimes returns bbox as { south, north, west, east }
      let bbox = null;
      if (item.boundingBox) {
        const { south, north, west, east } = item.boundingBox;
        bbox = [south, north, west, east]; // OSM format: [south, north, west, east]
      }

      return {
        name: item.placeName || item.address || 'Unknown',
        lat: parseFloat(item.lat) || 0,
        lng: parseFloat(item.lng) || 0,
        display: item.address || item.placeName,
        displayName: item.placeName || item.address,
        polygon: polygon,
        bbox: bbox,
        place_id: item.placeId || `mappls_${Math.random()}`
      };
    });
  } catch (error) {
    console.error('Mappls search error:', error);
    return [];
  }
}

// ─── Select Parent City ────────────────────────────────────────────



// ─── Main Component ──────────────────────────────────────────────────
export default function ZoneManagement({ isDark = false }) {
  const theme = useMemo(() => isDark ? {
    bg: "#0f1419",
    surface: "#1a1f26",
    border: "#282e38",
    text: "#e4e6eb",
    textSecondary: "#8a8d91",
    textMuted: "#5c6066",
    primary: "#0a66c2",
    primaryLight: "#0a66c250",
    success: "#31a24c",
    successLight: "#31a24c20",
    danger: "#e85d75",
    dangerLight: "#e85d7520",
    warning: "#f5a623",
    warningLight: "#f5a62320",
  } : {
    bg: "#ffffff",
    surface: "#f8f9fa",
    border: "#e5e7eb",
    text: "#1a1a1a",
    textSecondary: "#6b7280",
    textMuted: "#9ca3af",
    primary: "#0a66c2",
    primaryLight: "#0a66c215",
    success: "#31a24c",
    successLight: "#31a24c15",
    danger: "#e85d75",
    dangerLight: "#e85d7515",
    warning: "#f5a623",
    warningLight: "#f5a62320",
  }, [isDark]);

  // ─── State ──────────────────────────────────────────────────────────
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);
  const [mapsReady, setMapsReady] = useState(false);

  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const polygonsRef = useRef(new Map());
  const drawingPoly = useRef(null);
  const editablePoly = useRef(null);
// Selected areas ke liye state
const [selectedAreas, setSelectedAreas] = useState([]);
// Selected areas ki map layers store karne ke liye
const selectedAreaLayers = useRef(new Map());
  const [mode, setMode] = useState('view');
  const [editId, setEditId] = useState(null);
  const [formName, setFormName] = useState('');
  const [formType, setFormType] = useState('allowed');
  const [drawnCoords, setDrawnCoords] = useState([]);

  const [history, setHistory] = useState([]);
  const [historyIndex, setHistoryIndex] = useState(-1);

  const [areaInfo, setAreaInfo] = useState({ area: null, perimeter: null, points: 0 });
  // const [satellite, setSatellite] = useState(false);
  // const tileLayerRef = useRef(null);


  // ─── Map Style: Street / Satellite / Hybrid ─────────────────────────
const [mapStyle, setMapStyle] = useState('hybrid');
const [removePointMode, setRemovePointMode] = useState(false);

const baseLayerRef = useRef(null);
const labelsLayerRef = useRef(null);
  // ─── Location Search State ──────────────────────────────────────────
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const searchTimer = useRef(null);
const [searching, setSearching] = useState(false);

// Parent city — e.g. Gwalior
const [selectedCity, setSelectedCity] = useState(null);
// ─── Area Search Inside Selected City ──────────────────────────────
const [areaQuery, setAreaQuery] = useState('');
const [areaResults, setAreaResults] = useState([]);
const [areaSearching, setAreaSearching] = useState(false);
const [showAreaResults, setShowAreaResults] = useState(false);

const areaSearchTimer = useRef(null);

// Temporary preview polygon
const areaPreviewRef = useRef(null);

const cityBoundaryRef = useRef(null); // City ka boundary layer store karega
  // ─── API calls using your Fetchnodeservices ──────────────────────
  const loadZones = useCallback(async () => {
    try {
      const res = await getData('admin/settings/regions');
      if (res.error) {
        console.error('API error:', res.error);
        setMsg({ text: 'Error loading zones: ' + res.error, type: 'error' });
        setZones([]);
      } else if (res.status) {
        console.log('✅ Loaded zones:', res.data);
        setZones(res.data);
      } else {
        setMsg({ text: res.message || 'Failed to load zones', type: 'error' });
        setZones([]);
      }
    } catch (err) {
      console.error('❌ Exception:', err);
      setMsg({ text: 'Error loading zones', type: 'error' });
      setZones([]);
    }
  }, []);

  const createZone = async (data) => {
    const res = await postData('admin/settings/regions', data);
    if (res.error) throw new Error(res.error);
    return res;
  };

  const updateZone = async (id, data) => {
    const res = await putData(`admin/settings/regions/${id}`, data);
    if (res.error) throw new Error(res.error);
    return res;
  };

  const deleteZoneApi = async (id) => {
    const res = await deleteData(`admin/settings/regions/${id}`);
    if (res.error) throw new Error(res.error);
    return res;
  };

  useEffect(() => {
    setLoading(true);
    loadZones().finally(() => setLoading(false));
  }, [loadZones]);

  // ─── Leaflet init ──────────────────────────────────────────────────
  useEffect(() => {
    loadLeaflet().then(() => setMapsReady(true));
  }, []);

  useEffect(() => {
    if (!mapsReady || !mapRef.current || mapInstance.current) return;
    const map = L.map(mapRef.current).setView([26.2389, 75.8659], 12);
    // const tileLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    //   maxZoom: 19,
    //   attribution: '© OpenStreetMap',
    // }).addTo(map);
    // tileLayerRef.current = tileLayer;

    // ─── Default HYBRID Map ─────────────────────────────────────────────

// 1. Satellite imagery base
// const baseLayer = L.tileLayer(
//   'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
//   {
//     maxZoom: 20,
//     attribution: 'Tiles © Esri'
//   }
// ).addTo(map);

// baseLayerRef.current = baseLayer;


// // 2. Roads / city / place labels overlay
// const labelsLayer = L.tileLayer(
//   'https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}',
//   {
//     maxZoom: 20,
//     opacity: 1,
//     attribution: 'Labels © Esri'
//   }
// ).addTo(map);

// labelsLayerRef.current = labelsLayer;

// ─── Mappls Tile Layer (Vector + Labels) ────────────────────────────
const MAPPLS_API_KEY = 'cnmdcjrbwcbzhkzekxgfrjtivauibmsicgdb'; // <-- Aapki key

// 1. Base map – vector tiles (roads, buildings, landmarks)
// const MAPPLS_API_KEY = 'cnmdcjrbwcbzhkzekxgfrjtivauibmsicgdb'; // tumhari key

const baseLayer = L.tileLayer(
  `https://apis.mapmyindia.com/raster-tiles/v1/map/{z}/{x}/{y}.png?key=${MAPPLS_API_KEY}`,
  {
    maxZoom: 20,
    attribution: '© MapmyIndia',
    tileSize: 256,
  }
).addTo(map);
baseLayerRef.current = baseLayer;
// 2. Labels – agar vector tiles mein already labels hain toh iski zaroorat nahi,
//    lekin agar chahiye toh Mappls ka label layer bhi add kar sakte ho.
//    Hum isko abhi skip kar rahe hain kyunki vector tiles mein hi sab aa jata hai.
//    Agar phir bhi labels chahiye toh yeh URL use karo:
//    `https://apis.mappls.com/advancedmaps/v1/${MAPPLS_API_KEY}/{z}/{x}/{y}/vector?type=labels`
//    labelsLayerRef.current = L.tileLayer(...).addTo(map);

// labelsLayerRef.current = null; // Agar labels layer nahi use kar rahe toh

    // map.pm.setGlobalOptions({
    //   allowSelfIntersection: false,
    //   snappable: false,
    //   snapDistance: 0,
    // });

    map.pm.setGlobalOptions({

  // Polygon khud ko cross nahi karega
  allowSelfIntersection: false,

  // Automatic snapping OFF
  snappable: false,

  snapDistance: 0,

  // Important:
  // Right-click vertex removal ko allow karta hai
  preventMarkerRemoval: false,
});

    map.on('pm:create', async (e) => {
      if (drawingPoly.current) {
        try { drawingPoly.current.remove(); } catch {}
      }
      drawingPoly.current = e.layer;
      const coords = polyToCoords(e.layer);
      setDrawnCoords(coords);
      updateAreaStats(coords);

      const centroid = getPolygonCentroid(coords);
      if (centroid) {
        const address = await getAddressFromCoords(centroid.lat, centroid.lng);
        setFormName(address);
      }

      e.layer.on('pm:edit', () => {
        const newCoords = polyToCoords(e.layer);
        setDrawnCoords(newCoords);
        updateAreaStats(newCoords);
        pushHistory(newCoords);
      });
      pushHistory(coords);
    });

    mapInstance.current = map;
  }, [mapsReady]);

  // ─── Render zones on map ──────────────────────────────────────────
  useEffect(() => {
    if (!mapInstance.current || !mapsReady) return;

     
    polygonsRef.current.forEach(p => { try { p.remove(); } catch {} });
    polygonsRef.current.clear();

    const filtered = zones.filter(z => {
      if (filter === 'allowed' && z.zone_type !== 'allowed') return false;
      if (filter === 'blacklisted' && z.zone_type !== 'blacklisted') return false;
      if (filter === 'active' && String(z.status) !== '1') return false;
      if (searchTerm && !z.name.toLowerCase().includes(searchTerm.toLowerCase())) return false;
      return true;
    });

    filtered.forEach(zone => {
      if (!zone.polygon || zone.polygon.length < 3) {
        console.warn(`⚠️ Zone ${zone.name} has invalid polygon`);
        return;
      }

      const isActive = String(zone.status) === '1';
      const color = zone.zone_type === 'blacklisted' ? theme.danger : theme.success;
      const poly = L.polygon(
        zone.polygon.map(p => [p.lat, p.lng]),
        {
  fillColor: color,

  // Satellite/Hybrid me buildings clearly visible rahengi
  fillOpacity:
    mapStyle === 'street'
      ? (isActive ? 0.20 : 0.06)
      : (isActive ? 0.10 : 0.04),

  color: color,

  // Satellite image par boundary clear dikhe
  weight:
    mapStyle === 'street'
      ? (isActive ? 3 : 2)
      : (isActive ? 4 : 2.5),

  opacity:
    isActive ? 1 : 0.55,
}
      ).addTo(mapInstance.current);

      poly.bindPopup(`
        <div style="font-family:system-ui;padding:4px;min-width:140px;">
          <strong>${zone.name}</strong><br/>
          <span style="color:${zone.zone_type === 'blacklisted' ? '#e85d75' : '#31a24c'};font-size:12px;font-weight:600;">
            ${zone.zone_type === 'blacklisted' ? 'BLACKLISTED' : 'ALLOWED'}
          </span>
          <span style="margin-left:8px;color:${isActive ? '#31a24c' : '#999'};font-size:12px;">
            ${isActive ? 'Active' : 'Inactive'}
          </span>
        </div>
      `);

      poly.on('click', () => focusOnZone(zone.id));
      polygonsRef.current.set(zone.id, poly);
    },[mapsReady]
  
  );
  // }, [zones, mapsReady, filter, searchTerm, theme]);
  }, [
  zones,
  mapsReady,
  filter,
  searchTerm,
  theme,
  mapStyle
]);



  // ─── Satellite toggle ──────────────────────────────────────────────
  // useEffect(() => {
  //   if (!mapInstance.current || !tileLayerRef.current) return;
  //   if (satellite) {
  //     tileLayerRef.current.setUrl('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}');
  //   } else {
  //     tileLayerRef.current.setUrl('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png');
  //   }
  // }, [satellite]);

  // ─── Street / Satellite / Hybrid Switcher ──────────────────────────
// useEffect(() => {

//   const map = mapInstance.current;

//   if (!map || !baseLayerRef.current) return;


//   // Remove labels first
//   if (
//     labelsLayerRef.current &&
//     map.hasLayer(labelsLayerRef.current)
//   ) {
//     map.removeLayer(labelsLayerRef.current);
//   }


//   // ───────── STREET ─────────
//   if (mapStyle === 'street') {

//     baseLayerRef.current.setUrl(
//       'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
//     );

//   }


//   // ───────── SATELLITE ─────────
//   else if (mapStyle === 'satellite') {

//     baseLayerRef.current.setUrl(
//       'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
//     );

//   }


//   // ───────── HYBRID ─────────
//   else if (mapStyle === 'hybrid') {

//     baseLayerRef.current.setUrl(
//       'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
//     );

//     // Add labels over satellite
//     if (labelsLayerRef.current) {

//       labelsLayerRef.current.addTo(map);

//       try {
//         labelsLayerRef.current.bringToFront();
//       } catch (e) {
//         console.log('Label layer front error:', e);
//       }

//     }

//   }


//   // Keep our delivery zones above map tiles
//   polygonsRef.current.forEach(layer => {

//     try {
//       layer.bringToFront();
//     } catch {}

//   });

//   try {
//     drawingPoly.current?.bringToFront();
//   } catch {}

//   try {
//     editablePoly.current?.bringToFront();
//   } catch {}


// }, [mapStyle]);



useEffect(() => {
  const map = mapInstance.current;
  if (!map || !baseLayerRef.current) return;
  // ...
  if (mapStyle === 'street') {
    baseLayerRef.current.setUrl(
      // `https://apis.mappls.com/advancedmaps/v1/${MAPPLS_API_KEY}/{z}/{x}/{y}/vector?type=default`
  `https://apis.mapmyindia.com/raster-tiles/v1/map/{z}/{x}/{y}.png?key=${MAPPLS_API_KEY}`

    );
  } else if (mapStyle === 'satellite') {
    baseLayerRef.current.setUrl(
      // `https://apis.mappls.com/advancedmaps/v1/${MAPPLS_API_KEY}/{z}/{x}/{y}/vector?type=satellite`
  `https://apis.mapmyindia.com/raster-tiles/v1/satellite/{z}/{x}/{y}.png?key=${MAPPLS_API_KEY}`

    );
  } else if (mapStyle === 'hybrid') {
    baseLayerRef.current.setUrl(
      // `https://apis.mappls.com/advancedmaps/v1/${MAPPLS_API_KEY}/{z}/{x}/{y}/vector?type=hybrid`
  `https://apis.mapmyindia.com/raster-tiles/v1/satellite/{z}/{x}/{y}.png?key=${MAPPLS_API_KEY}`

    );
  }
  // Labels layer – Mappls vector tiles mein labels already hain toh alag label layer ki zaroorat nahi.
  // Agar chahiye toh alag se label tile add karo, but abhi ke liye ignore.
}, [mapStyle]);
  // ─── Undo / Redo ────────────────────────────────────────────────────
  const pushHistory = (coords) => {
    const newHistory = history.slice(0, historyIndex + 1);
    newHistory.push(coords);
    setHistory(newHistory);
    setHistoryIndex(newHistory.length - 1);
  };

  const undo = () => {
    if (historyIndex > 0) {
      const prev = history[historyIndex - 1];
      setDrawnCoords(prev);
      setHistoryIndex(historyIndex - 1);
      updateAreaStats(prev);
      if (editablePoly.current) {
        editablePoly.current.setLatLngs(prev.map(p => [p.lat, p.lng]));
      } else if (drawingPoly.current) {
        drawingPoly.current.setLatLngs(prev.map(p => [p.lat, p.lng]));
      }
    }
  };

  const redo = () => {
    if (historyIndex < history.length - 1) {
      const next = history[historyIndex + 1];
      setDrawnCoords(next);
      setHistoryIndex(historyIndex + 1);
      updateAreaStats(next);
      if (editablePoly.current) {
        editablePoly.current.setLatLngs(next.map(p => [p.lat, p.lng]));
      } else if (drawingPoly.current) {
        drawingPoly.current.setLatLngs(next.map(p => [p.lat, p.lng]));
      }
    }
  };

  useEffect(() => {
    const handler = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'z') { e.preventDefault(); undo(); }
      if ((e.ctrlKey || e.metaKey) && e.key === 'y') { e.preventDefault(); redo(); }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [history, historyIndex]);


  // ─── Remove Polygon Point Mode ─────────────────────────────────────
const toggleRemovePointMode = () => {

  const poly =
    editablePoly.current ||
    drawingPoly.current;

  if (!poly) {
    showMsg(
      'First draw, select or edit a zone',
      'error'
    );
    return;
  }

  // Toggle mode
  const nextMode = !removePointMode;

  setRemovePointMode(nextMode);

  if (nextMode) {

    // Enable Geoman vertex editing
    try {
      poly.pm.enable({
        allowSelfIntersection: false,
        snappable: false,
      });
    } catch (error) {
      console.error(
        'Point edit enable error:',
        error
      );
    }

    showMsg(
      'Remove Point ON — right-click a boundary point to remove it'
    );

  } else {

    showMsg(
      'Remove Point mode OFF'
    );

  }
};
  // ─── Area stats ────────────────────────────────────────────────────
  // const updateAreaStats = (coords) => {
  //   if (!coords || coords.length < 3) {
  //     setAreaInfo({ area: null, perimeter: null, points: coords.length });
  //     return;
  //   }
  //   try {
  //     const poly = turf.polygon([coords.map(c => [c.lng, c.lat])]);
  //     const areaSqM = area(poly);
  //     const perimKm = length(poly, { units: 'kilometers' });
  //     setAreaInfo({
  //       area: areaSqM / 1e6,
  //       perimeter: perimKm,
  //       points: coords.length,
  //     });
  //   } catch {
  //     setAreaInfo({ area: null, perimeter: null, points: coords.length });
  //   }
  // };
// ─── Search Locality Inside Selected City ──────────────────────────
// const searchAreaInsideCity = async (query) => {

//   if (!selectedCity || !query || query.trim().length < 2) {
//     return [];
//   }

//   try {

//     setAreaSearching(true);

//     // Example:
//     // "Morar, Gwalior, Madhya Pradesh, India"
//     const fullQuery =
//       `${query.trim()}, ${selectedCity.name}, Madhya Pradesh, India`;

//     const url =
//       `https://nominatim.openstreetmap.org/search` +
//       `?q=${encodeURIComponent(fullQuery)}` +
//       `&format=json` +
//       `&addressdetails=1` +
//       `&limit=8` +
//       `&countrycodes=in` +
//       `&polygon_geojson=1`;

//     const response = await fetch(url);

//     const data = await response.json();

//     return data.map(item => {

//       let polygon = null;

//       // ─── Polygon ─────────────────────
//       if (
//         item.geojson &&
//         item.geojson.type === 'Polygon'
//       ) {

//         const coords =
//           item.geojson.coordinates[0];

//         polygon = coords.map(coord => ({
//           lat: Number(coord[1]),
//           lng: Number(coord[0])
//         }));

//       }

//       // ─── MultiPolygon ────────────────
//       else if (
//         item.geojson &&
//         item.geojson.type === 'MultiPolygon'
//       ) {

//         // Pick largest outer ring instead of blindly first polygon
//         const rings = item.geojson.coordinates
//           .map(poly => poly?.[0])
//           .filter(Boolean);

//         if (rings.length) {

//           const largestRing = rings.reduce(
//             (largest, current) =>
//               current.length > largest.length
//                 ? current
//                 : largest
//           );

//           polygon = largestRing.map(coord => ({
//             lat: Number(coord[1]),
//             lng: Number(coord[0])
//           }));

//         }

//       }

//       return {

//         name:
//           item.display_name
//             ?.split(',')[0]
//             ?.trim() || query,

//         display:
//           item.display_name,

//         lat:
//           Number(item.lat),

//         lng:
//           Number(item.lon),

//         bbox:
//           item.boundingbox || null,

//         polygon,

//         type:
//           item.type || '',

//         category:
//           item.category || '',

//         place_id:
//           item.place_id

//       };

//     });

//   } catch (error) {

//     console.error(
//       'Area search error:',
//       error
//     );

//     return [];

//   } finally {

//     setAreaSearching(false);

//   }

// };


// const searchAreaInsideCity = async (query) => {
//   if (!selectedCity || !query || query.trim().length < 2) {
//     return [];
//   }

//   try {
//     setAreaSearching(true);

//     // Multiple search variations
//     const searchQueries = [
//       `${query.trim()}, ${selectedCity.name}, Madhya Pradesh, India`,
//       `${query.trim()}, ${selectedCity.name}`,
//       `${query.trim()}`
//     ];

//     let allResults = [];

//     for (const q of searchQueries) {
//       const url =
//         `https://nominatim.openstreetmap.org/search` +
//         `?q=${encodeURIComponent(q)}` +
//         `&format=json` +
//         `&addressdetails=1` +
//         `&limit=12` +  // Zyada results
//         `&countrycodes=in` +
//         `&polygon_geojson=1`;

//       const response = await fetch(url);
//       const data = await response.json();

//       if (data && data.length) {
//         allResults = [...allResults, ...data];
//       }
//     }

//     // Remove duplicates based on place_id or display_name
//     const seen = new Set();
//     allResults = allResults.filter(item => {
//       const key = item.place_id || item.display_name;
//       if (seen.has(key)) return false;
//       seen.add(key);
//       return true;
//     });

//     return allResults.map(item => {
//       let polygon = null;

//       // ─── Polygon ─────────────────────
//       if (item.geojson && item.geojson.type === 'Polygon') {
//         const coords = item.geojson.coordinates[0];
//         polygon = coords.map(coord => ({
//           lat: Number(coord[1]),
//           lng: Number(coord[0])
//         }));
//       } else if (item.geojson && item.geojson.type === 'MultiPolygon') {
//         const rings = item.geojson.coordinates.map(poly => poly?.[0]).filter(Boolean);
//         if (rings.length) {
//           const largestRing = rings.reduce((largest, current) =>
//             current.length > largest.length ? current : largest
//           );
//           polygon = largestRing.map(coord => ({
//             lat: Number(coord[1]),
//             lng: Number(coord[0])
//           }));
//         }
//       }

//       // ─── Fallback: Bounding box se rectangle ───
//       if (!polygon && item.boundingbox && item.boundingbox.length === 4) {
//         const [south, north, west, east] = item.boundingbox.map(Number);
//         polygon = [
//           { lat: south, lng: west },
//           { lat: south, lng: east },
//           { lat: north, lng: east },
//           { lat: north, lng: west },
//           { lat: south, lng: west }
//         ];
//       }

//       return {
//         name: item.display_name?.split(',')[0]?.trim() || query,
//         display: item.display_name,
//         lat: Number(item.lat),
//         lng: Number(item.lon),
//         bbox: item.boundingbox || null,
//         polygon: polygon,
//         type: item.type || '',
//         category: item.category || '',
//         place_id: item.place_id || `${item.lat}_${item.lon}`
//       };
//     });

//   } catch (error) {
//     console.error('Area search error:', error);
//     return [];
//   } finally {
//     setAreaSearching(false);
//   }
// };


// ─── Mappls-based Area Search (inside selected city) ──────────────
const searchAreaInsideCity = async (query) => {
  if (!selectedCity || !query || query.trim().length < 2) {
    return [];
  }

  try {
    setAreaSearching(true);
    const MAPPLS_API_KEY = 'cnmdcjrbwcbzhkzekxgfrjtivauibmsicgdb';
    const cityLat = selectedCity.lat;
    const cityLng = selectedCity.lng;

    // Mappls Autosuggest with location bias (so that results are within city)
    // const url = `https://autosuggest.mappls.com/v1/places?query=${encodeURIComponent(query)}&location=${cityLat},${cityLng}&radius=20000&api_key=${MAPPLS_API_KEY}&limit=8`;

    const url = `https://autosuggest.mapmyindia.com/v1/places?query=${encodeURIComponent(query)}&location=${cityLat},${cityLng}&radius=20000&api_key=${MAPPLS_API_KEY}&limit=8`;
    const res = await fetch(url);
    const data = await res.json();

    return data.suggestions.map(item => {
      let polygon = null;
      if (item.geometry && item.geometry.type === 'Polygon') {
        const coords = item.geometry.coordinates[0];
        polygon = coords.map(coord => ({ lat: coord[1], lng: coord[0] }));
      }

      let bbox = null;
      if (item.boundingBox) {
        const { south, north, west, east } = item.boundingBox;
        bbox = [south, north, west, east];
      }

      return {
        name: item.placeName || item.address || query,
        display: item.address || item.placeName,
        lat: parseFloat(item.lat) || 0,
        lng: parseFloat(item.lng) || 0,
        polygon: polygon,
        bbox: bbox,
        place_id: item.placeId || `mappls_${Math.random()}`,
        type: item.type || '',
        category: item.category || ''
      };
    });
  } catch (error) {
    console.error('Mappls area search error:', error);
    return [];
  } finally {
    setAreaSearching(false);
  }
};

// ─── Preview Selected Area ─────────────────────────────────────────
const previewArea = (result) => {

  const map = mapInstance.current;

  if (!map || !result) return;


  // Remove old preview
  if (areaPreviewRef.current) {

    try {
      areaPreviewRef.current.remove();
    } catch {}

    areaPreviewRef.current = null;

  }


  // ─── Exact polygon available ───────────────────────
  if (
    result.polygon &&
    result.polygon.length >= 3
  ) {

    const preview = L.polygon(

      result.polygon.map(
        point => [
          point.lat,
          point.lng
        ]
      ),

      {
        color: '#f59e0b',

        weight: 4,

        opacity: 1,

        fillColor: '#f59e0b',

        fillOpacity: 0.12,

        dashArray: '8,6'
      }

    ).addTo(map);


    areaPreviewRef.current = preview;

    preview.bringToFront();


    map.fitBounds(
      preview.getBounds(),
      {
        padding: [50, 50],

        // Don't zoom ridiculously close
        maxZoom: 15
      }
    );

  }

  // ─── No polygon available ──────────────────────────
  else {

    map.flyTo(
      [
        result.lat,
        result.lng
      ],
      14,
      {
        duration: 0.8
      }
    );

  }


  setShowAreaResults(false);

};

  const updateAreaStats = (coords) => {
  if (!coords || coords.length < 3) {
    setAreaInfo({
      area: null,
      perimeter: null,
      points: coords?.length || 0
    });
    return;
  }

  try {
    // Convert our { lat, lng } format into GeoJSON [lng, lat]
    const ring = coords.map(c => [
      Number(c.lng),
      Number(c.lat)
    ]);

    // GeoJSON polygon must be closed:
    // first point and last point must be same
    const first = ring[0];
    const last = ring[ring.length - 1];

    if (
      first[0] !== last[0] ||
      first[1] !== last[1]
    ) {
      ring.push([...first]);
    }

    // Create valid Turf polygon
    const poly = turfPolygon([ring]);

    // Area in square meters
    const areaSqM = area(poly);

    // Perimeter using polygon boundary
    const boundary = lineString(ring);

    const perimeterKm = length(boundary, {
      units: 'kilometers'
    });

    setAreaInfo({
      area: areaSqM / 1000000,
      perimeter: perimeterKm,
      points: coords.length,
    });

  } catch (error) {

    console.error(
      '❌ Zone area calculation error:',
      error
    );

    setAreaInfo({
      area: null,
      perimeter: null,
      points: coords?.length || 0
    });
  }
};

  // ─── Focus on zone ─────────────────────────────────────────────────
  const focusOnZone = (id) => {
    const zone = zones.find(z => z.id === id);
    if (!zone || !zone.polygon?.length || !mapInstance.current) return;
    const bounds = L.latLngBounds(zone.polygon.map(p => [p.lat, p.lng]));
    mapInstance.current.fitBounds(bounds, { padding: [50, 50] });
  };

  // ─── CRUD ──────────────────────────────────────────────────────────
  const showMsg = (text, type = 'success') => {
    setMsg({ text, type });
    setTimeout(() => setMsg(null), 3000);
  };

// const selectCity = (result) => {
//   if (!result || !mapInstance.current) return;

//   const map = mapInstance.current;

//   // ─── 1. Purani city boundary layer hatao (agar hai toh) ───
//   if (cityBoundaryRef.current) {
//     try {
//       cityBoundaryRef.current.remove();
//     } catch (e) {}
//     cityBoundaryRef.current = null;
//   }

//   // ─── 2. City ka polygon map par draw karo (agar available hai) ───
//   if (result.polygon && result.polygon.length >= 3) {
//     const boundaryLayer = L.polygon(
//       result.polygon.map(p => [p.lat, p.lng]),
//       {
//         color: '#3b82f6',        // Bright blue
//         weight: 3,
//         opacity: 1,
//         fillColor: '#3b82f6',
//         fillOpacity: 0.05,       // Bahut light fill taaki neeche ki roads dikhein
//         dashArray: '8,6',        // Dashed line (preview jaisa)
//         interactive: false,      // Click/hover disable taaki disturb na kare
//       }
//     ).addTo(map);

//     // Layer ko sabse upar lao (zones ke neeche, but tiles ke upar)
//     try {
//       boundaryLayer.bringToFront();
//     } catch (e) {}

//     cityBoundaryRef.current = boundaryLayer;

//     // ─── 3. City ke exact boundary par zoom karo ───
//     map.fitBounds(boundaryLayer.getBounds(), {
//       padding: [40, 40],
//       maxZoom: 14, // Itna zoom mat karo ki boundary se bahar chala jaaye
//     });

//   } else {
//     // ─── Agar polygon nahi mila, toh sirf lat/lng par fly karo ───
//     if (result.bbox && result.bbox.length === 4) {
//       const [south, north, west, east] = result.bbox.map(Number);
//       map.fitBounds([
//         [south, west],
//         [north, east]
//       ], { padding: [30, 30] });
//     } else {
//       map.setView([Number(result.lat), Number(result.lng)], 12, { animate: true });
//     }
//   }

//   // ─── 4. State update karo ───
//   const cityData = {
//     name: result.name,
//     displayName: result.displayName,
//     lat: Number(result.lat),
//     lng: Number(result.lng),
//     bbox: result.bbox || null,
//     polygon: result.polygon || null,
//   };

//   setSelectedCity(cityData);
//   setSearchResults([]); // Search results band karo
//   setSearchTerm(result.name);

//   showMsg(`${result.name} selected — Blue dashed line shows city boundary. Now search areas inside it.`);
// };
const selectCity = (result) => {
  if (!result || !mapInstance.current) return;

  const map = mapInstance.current;

  // ─── 1. Purani boundary hatao ───
  if (cityBoundaryRef.current) {
    try { cityBoundaryRef.current.remove(); } catch (e) {}
    cityBoundaryRef.current = null;
  }

  // ─── 2. Debug logs ───
  console.log('City result:', result);
  console.log('Polygon?', result.polygon);
  console.log('BBox?', result.bbox);

  // ─── 3. Boundary points decide karo ───
  let boundaryPoints = null;

  if (result.polygon && result.polygon.length >= 3) {
    boundaryPoints = result.polygon;
    console.log('✅ Using exact polygon');
  } else if (result.bbox && result.bbox.length === 4) {
    const [south, north, west, east] = result.bbox.map(Number);
    boundaryPoints = [
      { lat: south, lng: west },
      { lat: south, lng: east },
      { lat: north, lng: east },
      { lat: north, lng: west },
      { lat: south, lng: west } // close
    ];
    console.log('📦 Using bounding box rectangle');
  } else {
    // ─── Fallback: 5 km radius circle around center ───
    const center = { lat: Number(result.lat), lng: Number(result.lon || result.lng) };
    const radiusKm = 5;
    const points = circleToPolygonPoints(center, radiusKm);
    boundaryPoints = points;
    console.log('⭕ Using circle fallback (5 km radius)');
  }

  // ─── 4. Boundary draw karo ───
  if (boundaryPoints && boundaryPoints.length >= 3) {
    const boundaryLayer = L.polygon(
      boundaryPoints.map(p => [p.lat, p.lng]),
      {
        color: '#3b82f6',
        weight: 3,
        opacity: 1,
        fillColor: '#3b82f6',
        fillOpacity: 0.05,
        dashArray: '8,6',
        interactive: false,
      }
    ).addTo(map);

    cityBoundaryRef.current = boundaryLayer;
    map.fitBounds(boundaryLayer.getBounds(), { padding: [40, 40], maxZoom: 14 });
  } else {
    // Kuch bhi nahi bana toh center par zoom karo
    map.setView([Number(result.lat), Number(result.lon || result.lng)], 12);
  }

  // ─── 5. State update ───
  const cityData = {
    name: result.name,
    displayName: result.displayName,
    lat: Number(result.lat),
    lng: Number(result.lon || result.lng),
    bbox: result.bbox || null,
    polygon: result.polygon || null,
  };

  setSelectedCity(cityData);
  setSearchResults([]);
  setSearchTerm(result.name);

  showMsg(`${result.name} selected — Boundary shown (blue dashed). Now search delivery areas inside it.`);
};

  const cancelDraw = () => {
    setMode('view');
    setEditId(null);
    setFormName('');
    setFormType('allowed');
    setDrawnCoords([]);
    setAreaInfo({ area: null, perimeter: null, points: 0 });
    setHistory([]);
    setHistoryIndex(-1);
    if (mapInstance.current?.pm) mapInstance.current.pm.disableDraw();
    if (drawingPoly.current) {
      try { drawingPoly.current.remove(); } catch {}
      drawingPoly.current = null;
    }
    if (editablePoly.current) {
      try { editablePoly.current.remove(); } catch {}
      editablePoly.current = null;
    }
    setZones([...zones]);
  };

  const startAdd = () => {
    if (!mapInstance.current) return;
    cancelDraw();
    setMode('add');
    setDrawnCoords([]);
    setHistory([]);
    setHistoryIndex(-1);
    mapInstance.current.pm.enableDraw('Polygon', { snappable: false, finishOn: 'dblclick' });
  };

  const startFreehand = () => {
    if (!mapInstance.current) return;
    cancelDraw();
    setMode('add');
    setDrawnCoords([]);
    setHistory([]);
    setHistoryIndex(-1);
    const map = mapInstance.current;
    let points = [];
    let isDrawing = false;
    let tempLine = null;

    const onMouseDown = (e) => {
      isDrawing = true;
      points = [{ lat: e.latlng.lat, lng: e.latlng.lng }];
      if (tempLine) { tempLine.remove(); tempLine = null; }
      tempLine = L.polyline([e.latlng], { color: theme.primary, weight: 2 }).addTo(map);
    };

    const onMouseMove = (e) => {
      if (!isDrawing) return;
      points.push({ lat: e.latlng.lat, lng: e.latlng.lng });
      tempLine.setLatLngs(points.map(p => [p.lat, p.lng]));
    };

    const onMouseUp = async () => {
      if (!isDrawing) return;
      isDrawing = false;
      if (tempLine) { tempLine.remove(); tempLine = null; }
      if (points.length < 3) {
        showMsg('Need at least 3 points for a polygon', 'error');
        return;
      }
      const poly = L.polygon(points.map(p => [p.lat, p.lng]), {
        fillColor: theme.primary,
        fillOpacity: 0.3,
        color: theme.primary,
        weight: 2,
      }).addTo(map);
      drawingPoly.current = poly;
      try {
  poly.bringToFront();
} catch {}

// Enable vertex editing
poly.pm.enable({
  allowSelfIntersection: false,
  snappable: false,
});
      const coords = polyToCoords(poly);
      setDrawnCoords(coords);
      updateAreaStats(coords);
      pushHistory(coords);

      const centroid = getPolygonCentroid(coords);
      if (centroid) {
        const address = await getAddressFromCoords(centroid.lat, centroid.lng);
        setFormName(address);
      }

      poly.pm.enable();
      poly.on('pm:edit', () => {
        const newCoords = polyToCoords(poly);
        setDrawnCoords(newCoords);
        updateAreaStats(newCoords);
        pushHistory(newCoords);
      });
      map.off('mousedown', onMouseDown);
      map.off('mousemove', onMouseMove);
      map.off('mouseup', onMouseUp);
    };

    map.on('mousedown', onMouseDown);
    map.on('mousemove', onMouseMove);
    map.on('mouseup', onMouseUp);
  };

  const startRadius = () => {
    if (!mapInstance.current) return;
    const radiusKm = parseFloat(window.prompt('Enter radius in kilometers:', '2'));
    if (isNaN(radiusKm) || radiusKm <= 0) return;
    cancelDraw();
    setMode('add');
    setDrawnCoords([]);
    setHistory([]);
    setHistoryIndex(-1);
    const map = mapInstance.current;
    const onMapClick = async (e) => {
      const center = { lat: e.latlng.lat, lng: e.latlng.lng };
      const points = circleToPolygonPoints(center, radiusKm);
      const poly = L.polygon(points.map(p => [p.lat, p.lng]), {
        fillColor: theme.primary,
        fillOpacity: 0.3,
        color: theme.primary,
        weight: 2,
      }).addTo(map);
      drawingPoly.current = poly;
      setDrawnCoords(points);
      updateAreaStats(points);
      pushHistory(points);

      const centroid = getPolygonCentroid(points);
      if (centroid) {
        const address = await getAddressFromCoords(centroid.lat, centroid.lng);
        setFormName(address);
      }

      poly.pm.enable();
      poly.on('pm:edit', () => {
        const newCoords = polyToCoords(poly);
        setDrawnCoords(newCoords);
        updateAreaStats(newCoords);
        pushHistory(newCoords);
      });
      map.off('click', onMapClick);
    };
    map.on('click', onMapClick);
  };

  const startEdit = (zone) => {
    if (!mapInstance.current) return;
    cancelDraw();
    setMode('edit');
    setEditId(zone.id);
    setFormName(zone.name);
    setFormType(zone.zone_type || 'allowed');
    const coords = zone.polygon || [];
    setDrawnCoords(coords);
    updateAreaStats(coords);
    setHistory([coords]);
    setHistoryIndex(0);

    const orig = polygonsRef.current.get(zone.id);
    if (orig) orig.remove();

    const poly = L.polygon(coords.map(p => [p.lat, p.lng]), {
      fillColor: zone.zone_type === 'blacklisted' ? theme.danger : theme.success,
      fillOpacity: 0.35,
      color: zone.zone_type === 'blacklisted' ? theme.danger : theme.success,
      weight: 3,
    }).addTo(mapInstance.current);
    editablePoly.current = poly;
    poly.pm.enable();
    poly.on('pm:edit', () => {
      const newCoords = polyToCoords(poly);
      setDrawnCoords(newCoords);
      updateAreaStats(newCoords);
      pushHistory(newCoords);
    });
    mapInstance.current.fitBounds(poly.getBounds(), { padding: [50, 50] });
  };

// ─── Area ko selected list me add karo ──────────────────────────
// const addAreaToBatch = (result) => {
//   if (!result.polygon || result.polygon.length < 3) {
//     showMsg('This area has no boundary polygon.', 'error');
//     return;
//   }

//   // Check if already selected
//   if (selectedAreas.some(a => a.place_id === result.place_id)) {
//     showMsg('Area already selected!', 'warning');
//     return;
//   }

//   // Add to state with default 'pending' type
//   const newArea = {
//     ...result,
//     type: 'pending', // pending, allowed, blacklisted
//   };

//   setSelectedAreas(prev => [...prev, newArea]);

//   // Draw polygon on map (neutral purple color)
//   if (mapInstance.current) {
//     const poly = L.polygon(
//       result.polygon.map(p => [p.lat, p.lng]),
//       {
//         color: '#8b5cf6', // Purple
//         weight: 3,
//         opacity: 0.8,
//         fillColor: '#8b5cf6',
//         fillOpacity: 0.1,
//         dashArray: '5,5',
//         interactive: true,
//       }
//     ).addTo(mapInstance.current);

//     // Store layer reference
//     selectedAreaLayers.current.set(result.place_id, poly);
//     mapInstance.current.fitBounds(poly.getBounds(), { padding: [30, 30] });
//   }

//   setShowAreaResults(false);
//   setAreaQuery('');
//   showMsg(`✅ "${result.name}" added to selection. Now choose Allow or Blacklist.`);
// };


  // ─── Area ko selected list me add karo (with fallback) ──────────
// const addAreaToBatch = (result) => {
//   // ─── 1. Polygon banane ki koshish ───
//   let polygon = result.polygon;

//   // Agar polygon nahi hai, toh bbox se rectangle banao
//   if (!polygon || polygon.length < 3) {
//     if (result.bbox && result.bbox.length === 4) {
//       const [south, north, west, east] = result.bbox.map(Number);
//       polygon = [
//         { lat: south, lng: west },
//         { lat: south, lng: east },
//         { lat: north, lng: east },
//         { lat: north, lng: west },
//         { lat: south, lng: west } // close
//       ];
//       console.log('📦 Using bbox rectangle for', result.name);
//     } else {
//       // Agar bbox bhi nahi, toh center ke around 2km circle
//       const center = { lat: Number(result.lat), lng: Number(result.lng) };
//       polygon = circleToPolygonPoints(center, 2); // 2 km radius
//       console.log('⭕ Using circle fallback for', result.name);
//     }
//   }

//   // ─── 2. Agar polygon ab bhi nahi bana toh error ───
//   if (!polygon || polygon.length < 3) {
//     showMsg(`"${result.name}" has no boundary data. Try manual drawing.`, 'error');
//     return;
//   }

//   // ─── 3. Check if already selected ───
//   if (selectedAreas.some(a => a.place_id === result.place_id)) {
//     showMsg('Area already selected!', 'warning');
//     return;
//   }

//   // ─── 4. Add to state ───
//   const newArea = {
//     ...result,
//     polygon: polygon, // fallback polygon override
//     type: 'pending',
//   };

//   setSelectedAreas(prev => [...prev, newArea]);

//   // ─── 5. Draw polygon on map ───
//   if (mapInstance.current) {
//     const poly = L.polygon(
//       polygon.map(p => [p.lat, p.lng]),
//       {
//         color: '#8b5cf6',
//         weight: 3,
//         opacity: 0.8,
//         fillColor: '#8b5cf6',
//         fillOpacity: 0.1,
//         dashArray: '5,5',
//         interactive: true,
//       }
//     ).addTo(mapInstance.current);

//     selectedAreaLayers.current.set(result.place_id || Date.now(), poly);
//     mapInstance.current.fitBounds(poly.getBounds(), { padding: [30, 30] });
//   }

//   setShowAreaResults(false);
//   setAreaQuery('');
//   showMsg(`✅ "${result.name}" added (using fallback boundary). Now choose Allow or Blacklist.`);
// };

const addAreaToBatch = (result) => {
  // Agar polygon nahi hai, toh fallback circle banao
  let polygon = result.polygon;
  if (!polygon || polygon.length < 3) {
    const center = { lat: result.lat, lng: result.lng };
    const radiusKm = 2; // 2 km radius
    polygon = circleToPolygonPoints(center, radiusKm);
    showMsg(`⚠️ "${result.name}" has no boundary, using ${radiusKm}km circle fallback.`, 'warning');
  }

  // Check if already selected
  if (selectedAreas.some(a => a.place_id === result.place_id)) {
    showMsg('Area already selected!', 'warning');
    return;
  }

  const newArea = {
    ...result,
    polygon: polygon,
    type: 'pending',
  };

  setSelectedAreas(prev => [...prev, newArea]);

  if (mapInstance.current) {
    const poly = L.polygon(
      polygon.map(p => [p.lat, p.lng]),
      {
        color: '#8b5cf6',
        weight: 3,
        opacity: 0.8,
        fillColor: '#8b5cf6',
        fillOpacity: 0.1,
        dashArray: '5,5',
        interactive: true,
      }
    ).addTo(mapInstance.current);

    selectedAreaLayers.current.set(result.place_id || result.lat + '_' + result.lng, poly);
    mapInstance.current.fitBounds(poly.getBounds(), { padding: [30, 30] });
  }

  setShowAreaResults(false);
  setAreaQuery('');
  showMsg(`✅ "${result.name}" added to selection. Now choose Allow or Blacklist.`);
};


// ─── Selected area ka type change karo (Allow / Blacklist) ──────
const updateSelectedAreaType = async (index, type) => {
  const area = selectedAreas[index];
  if (!area) return;

  // Update local state
  const updatedAreas = [...selectedAreas];
  updatedAreas[index].type = type;
  setSelectedAreas(updatedAreas);

  // Update map layer color
  const layer = selectedAreaLayers.current.get(area.place_id);
  if (layer) {
    const color = type === 'allowed' ? '#31a24c' : '#e85d75';
    layer.setStyle({
      color: color,
      fillColor: color,
      fillOpacity: 0.25,
      dashArray: null, // Solid line after decision
    });
    layer.bringToFront();
  }

  // ─── Auto-save zone to database ──────────────────────────────
  setSaving(true);
  try {
    const res = await createZone({
      name: area.name.trim(),
      polygon: area.polygon,
      zone_type: type, // 'allowed' or 'blacklisted'
      status: '1',
    });
    if (res.status) {
      showMsg(`✅ "${area.name}" marked as ${type.toUpperCase()} and saved!`);
      await loadZones(); // Refresh list
    } else {
      throw new Error(res.message || 'Failed to save');
    }
  } catch (e) {
    showMsg(e.message || 'Error saving zone', 'error');
    // Revert type on error
    const revertAreas = [...selectedAreas];
    revertAreas[index].type = 'pending';
    setSelectedAreas(revertAreas);
    // Revert color
    if (layer) {
      layer.setStyle({
        color: '#8b5cf6',
        fillColor: '#8b5cf6',
        fillOpacity: 0.1,
        dashArray: '5,5',
      });
    }
  } finally {
    setSaving(false);
  }
};

// ─── Selected area remove karo ──────────────────────────────────
const removeSelectedArea = (index) => {
  const area = selectedAreas[index];
  if (!area) return;

  // Remove layer from map
  const layer = selectedAreaLayers.current.get(area.place_id);
  if (layer) {
    try { layer.remove(); } catch (e) {}
    selectedAreaLayers.current.delete(area.place_id);
  }

  // Remove from state
  const updatedAreas = [...selectedAreas];
  updatedAreas.splice(index, 1);
  setSelectedAreas(updatedAreas);
  showMsg(`Removed "${area.name}" from selection`);
};


// ─── Directly create zone from searched area ──────────────────────
const createZoneFromArea = async (result, type) => {
  if (!result.polygon || result.polygon.length < 3) {
    showMsg('This area has no boundary polygon. Please draw manually.', 'error');
    return;
  }


  // Cancel current drawing if any
  if (drawingPoly.current) {
    try { drawingPoly.current.remove(); } catch {}
    drawingPoly.current = null;
  }

  // Set the form data
  const name = result.name || 'Unnamed Area';
  setFormName(name);
  setFormType(type);
  setDrawnCoords(result.polygon);

  // Calculate stats
  updateAreaStats(result.polygon);

  // Show polygon on map instantly
  if (mapInstance.current) {
    const poly = L.polygon(result.polygon.map(p => [p.lat, p.lng]), {
      fillColor: type === 'blacklisted' ? theme.danger : theme.success,
      fillOpacity: 0.35,
      color: type === 'blacklisted' ? theme.danger : theme.success,
      weight: 3,
    }).addTo(mapInstance.current);

    // Store as drawing poly so it can be edited later
    drawingPoly.current = poly;
    poly.pm.enable();
    poly.on('pm:edit', () => {
      const newCoords = polyToCoords(poly);
      setDrawnCoords(newCoords);
      updateAreaStats(newCoords);
    });
    mapInstance.current.fitBounds(poly.getBounds(), { padding: [30, 30] });
  }

  // Auto-save the zone (optional: agar auto-save nahi chahta toh hata dena)
  // Yahan main auto-save kar raha hoon taaki tera kaam asaan ho.
  setSaving(true);
  try {
    const res = await createZone({
      name: name.trim(),
      polygon: result.polygon,
      zone_type: type,
      status: '1',
    });
    if (res.status) {
      showMsg(`✅ "${name}" marked as ${type.toUpperCase()} and saved!`);
      await loadZones();
      // Cancel draw mode to reset UI
      cancelDraw();
      // But keep city boundary visible (optional)
    } else {
      throw new Error(res.message || 'Failed to save');
    }
  } catch (e) {
    showMsg(e.message || 'Error saving zone', 'error');
  } finally {
    setSaving(false);
  }
};


  const handleSave = async () => {
    if (!formName.trim()) { showMsg('Zone name is required', 'error'); return; }
    if (drawnCoords.length < 3) { showMsg('Draw a polygon first (at least 3 points)', 'error'); return; }

    setSaving(true);
    try {
      if (mode === 'add') {
        const res = await createZone({
          name: formName.trim(),
          polygon: drawnCoords,
          zone_type: formType,
          status: '1',
        });
        if (res.status) {
          showMsg('Zone created successfully');
          await loadZones();
          cancelDraw();
        } else {
          throw new Error(res.message || 'Failed to create');
        }
      } else if (mode === 'edit' && editId) {
        const res = await updateZone(editId, {
          name: formName.trim(),
          polygon: drawnCoords,
          zone_type: formType,
        });
        if (res.status) {
          showMsg('Zone updated');
          await loadZones();
          cancelDraw();
        } else {
          throw new Error(res.message || 'Failed to update');
        }
      }
    } catch (e) {
      showMsg(e.message || 'Error saving', 'error');
    } finally {
      setSaving(false);
    }
  };

  const toggleStatus = async (zone) => {
    const newStatus = String(zone.status) === '1' ? '0' : '1';
    const res = await updateZone(zone.id, { status: newStatus });
    if (res.status) { showMsg(`Zone ${newStatus === '1' ? 'activated' : 'deactivated'}`); await loadZones(); }
    else showMsg(res.message || 'Error', 'error');
  };

  const toggleType = async (zone) => {
    const newType = zone.zone_type === 'blacklisted' ? 'allowed' : 'blacklisted';
    const res = await updateZone(zone.id, { zone_type: newType });
    if (res.status) { showMsg(`Zone marked as ${newType}`); await loadZones(); }
    else showMsg(res.message || 'Error', 'error');
  };

  const handleDelete = async (zone) => {
    if (!confirm(`Delete "${zone.name}"? This cannot be undone.`)) return;
    const res = await deleteZoneApi(zone.id);
    if (res.status) { showMsg('Zone deleted'); await loadZones(); }
    else showMsg(res.message || 'Error', 'error');
  };

  // ─── Filtered zones & stats ───────────────────────────────────────
  const filteredZones = useMemo(() => {
    let list = zones;
    if (filter === 'allowed') list = list.filter(z => z.zone_type === 'allowed');
    else if (filter === 'blacklisted') list = list.filter(z => z.zone_type === 'blacklisted');
    else if (filter === 'active') list = list.filter(z => String(z.status) === '1');
    if (searchTerm) list = list.filter(z => z.name.toLowerCase().includes(searchTerm.toLowerCase()));
    return list;
  }, [zones, filter, searchTerm]);

  const stats = useMemo(() => ({
    total: zones.length,
    allowed: zones.filter(z => z.zone_type === 'allowed').length,
    blacklisted: zones.filter(z => z.zone_type === 'blacklisted').length,
    active: zones.filter(z => String(z.status) === '1').length,
  }), [zones]);

  // ─── Inline Spinner ──────────────────────────────────────────────────
  const SpinnerInline = () => (
    <div className="spinner" style={{
      border: '4px solid rgba(0,0,0,0.1)',
      borderRadius: '50%',
      borderTop: '4px solid #0a66c2',
      width: '24px',
      height: '24px',
      animation: 'spin 0.8s linear infinite',
      margin: '0 auto',
    }} />
  );

  // ─── Render ──────────────────────────────────────────────────────────
  if (loading && !mapsReady) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <SpinnerInline />
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <div style={{
      height: '100vh',
      background: theme.bg,
      padding: '20px 24px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Inter", sans-serif',
      color: theme.text,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    }}>
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        button { transition: all 0.2s ease; cursor: pointer; }
        button:hover { opacity: 0.85; }
        button:active { transform: scale(0.98); }
        input:focus { outline: none; border-color: ${theme.primary} !important; }
        ::-webkit-scrollbar { width: 5px; height: 5px; }
        ::-webkit-scrollbar-track { background: ${theme.border}; border-radius: 3px; }
        ::-webkit-scrollbar-thumb { background: ${theme.primary}; border-radius: 3px; }
        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
      `}</style>

      {/* Header */}
      <div style={{ marginBottom: '20px', flexShrink: 0 }}>
        <h1 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '6px', letterSpacing: '-0.3px' }}>
          Zone Management
        </h1>
        <p style={{ fontSize: '13px', color: theme.textSecondary }}>
          Create and manage delivery zones for your business operations
        </p>
      </div>

      {/* Stats */}
      <div style={{ display: 'flex', gap: '14px', marginBottom: '20px', flexWrap: 'wrap', flexShrink: 0 }}>
        {[
          { label: 'Total Zones', value: stats.total, color: theme.primary },
          { label: 'Allowed Zones', value: stats.allowed, color: theme.success },
          { label: 'Blacklisted Zones', value: stats.blacklisted, color: theme.danger },
          { label: 'Active Zones', value: stats.active, color: theme.warning },
        ].map(s => (
          <div key={s.label} style={{
            background: theme.surface,
            border: `1px solid ${theme.border}`,
            borderRadius: '10px',
            padding: '14px 18px',
            flex: 1,
            minWidth: '100px',
          }}>
            <div style={{ fontSize: '11px', color: theme.textSecondary, marginBottom: '6px', letterSpacing: '0.3px' }}>
              {s.label}
            </div>
            <div style={{ fontSize: '28px', fontWeight: 700, color: s.color }}>
              {s.value}
            </div>
          </div>
        ))}
      </div>

      {msg && (
        <div style={{
          padding: '10px 16px',
          borderRadius: '8px',
          marginBottom: '14px',
          background: msg.type === 'error' ? theme.dangerLight : theme.successLight,
          color: msg.type === 'error' ? theme.danger : theme.success,
          fontSize: '13px',
          fontWeight: 500,
        }}>
          {msg.text}
        </div>
      )}

      {/* Main Layout */}
      <div style={{ display: 'flex', gap: '20px', flex: 1, minHeight: 0, overflow: 'hidden' }}>

        {/* Left Panel: Map */}
        <div style={{ flex: 1, minWidth: '300px', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <div style={{
            background: theme.surface,
            border: `1px solid ${theme.border}`,
            borderRadius: '12px',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          }}>
            {/* Toolbar & Search */}
            <div style={{ padding: '10px 14px', borderBottom: `1px solid ${theme.border}`, flexShrink: 0 }}>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '8px' }}>
                {/* Search Input with Dropdown */}
                <div style={{ position: 'relative', flex: 1, minWidth: '150px' }}>
                  <input
                    type="text"
                    placeholder="Search city or place..."
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setShowResults(true);
                      if (searchTimer.current) clearTimeout(searchTimer.current);
                      if (e.target.value.length >= 2) {
                        searchTimer.current = setTimeout(async () => {
                          const results = await searchLocation(e.target.value);
                          setSearchResults(results);
                        }, 300);
                      } else {
                        setSearchResults([]);
                      }
                    }}
                    onFocus={() => searchResults.length > 0 && setShowResults(true)}
                    onBlur={() => setTimeout(() => setShowResults(false), 200)}
                    style={{
                      width: '100%',
                      padding: '7px 10px',
                      background: theme.bg,
                      border: `1px solid ${theme.border}`,
                      borderRadius: '6px',
                      fontSize: '12px',
                      color: theme.text,
                    }}
                  />
                  {showResults && searchResults.length > 0 && (
                    <div style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      right: 0,
                      background: theme.surface,
                      border: `1px solid ${theme.border}`,
                      borderRadius: '6px',
                      maxHeight: '250px',
                      overflowY: 'auto',
                      zIndex: 1000,
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    }}>
                      {searchResults.map((result, idx) => (
                        <div
                          key={idx}
                          style={{
                            padding: '8px 12px',
                            fontSize: '12px',
                            color: theme.text,
                            borderBottom: `1px solid ${theme.border}`,
                            cursor: 'pointer',
                          }}
                          onMouseEnter={(e) => e.target.style.background = theme.primaryLight}
                          onMouseLeave={(e) => e.target.style.background = 'transparent'}
                        >
                          <div style={{ fontWeight: 500 }}>{result.name}</div>
                          <div style={{ fontSize: '10px', color: theme.textMuted }}>{result.display}</div>
                          {result.polygon && result.polygon.length > 3 ? (
//                             <button
//                               onMouseDown={(e) => {
//                                 e.stopPropagation();
//                                 // Use city boundary as zone
//                                 setDrawnCoords(result.polygon);
//                                 setFormName(result.name + ' (City)');
//                                 setMode('add');
//                                 // Calculate accurate area/perimeter immediately
// updateAreaStats(result.polygon);

// // Start history so Undo/Edit works correctly
// setHistory([result.polygon]);
// setHistoryIndex(0);
//                                 // Clear existing drawing
//                                 if (drawingPoly.current) {
//                                   try { drawingPoly.current.remove(); } catch {}
//                                   drawingPoly.current = null;
//                                 }
//                                 if (mapInstance.current) {
//                                   const poly = L.polygon(result.polygon.map(p => [p.lat, p.lng]), {
//                                     fillColor: theme.primary,
//                                     fillOpacity: 0.3,
//                                     color: theme.primary,
//                                     weight: 2,
//                                   }).addTo(mapInstance.current);
//                                   drawingPoly.current = poly;
//                                   // Enable editing
//                                   poly.pm.enable();
//                                   poly.on('pm:edit', () => {
//                                     const newCoords = polyToCoords(poly);
//                                     setDrawnCoords(newCoords);
//                                     updateAreaStats(newCoords);
//                                   });
//                                   mapInstance.current.fitBounds(poly.getBounds(), { padding: [30, 30] });
//                                 }
//                                 setShowResults(false);
//                               }}
//                               style={{
//                                 marginTop: '4px',
//                                 padding: '2px 12px',
//                                 fontSize: '10px',
//                                 background: theme.primary,
//                                 color: '#fff',
//                                 border: 'none',
//                                 borderRadius: '4px',
//                                 cursor: 'pointer',
//                               }}
//                             >
//                               ➕ Use as Zone
//                             </button>

<button
  onClick={() => selectCity(result)}
  style={{
    padding: '5px 10px',
    background: theme.primary,
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    fontSize: '10px',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
  }}
>
  📍 Select City
</button>
                          ) : (
                            <button
                              onMouseDown={() => {
                                if (mapInstance.current) {
                                  mapInstance.current.flyTo([result.lat, result.lng], 14, { duration: 1 });
                                }
                                setSearchQuery(result.name);
                                setShowResults(false);
                                setSearchResults([]);
                              }}
                              style={{
                                marginTop: '4px',
                                padding: '2px 12px',
                                fontSize: '10px',
                                background: 'transparent',
                                color: theme.textSecondary,
                                border: `1px solid ${theme.border}`,
                                borderRadius: '4px',
                                cursor: 'pointer',
                              }}
                            >
                              📍 Fly to
                            </button>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Toolbar Buttons */}
                {/* <button
                  onClick={() => setSatellite(!satellite)}
                  style={{
                    padding: '6px 12px',
                    background: satellite ? theme.primary : theme.bg,
                    color: satellite ? '#fff' : theme.textSecondary,
                    border: `1px solid ${theme.border}`,
                    borderRadius: '6px',
                    fontSize: '11px',
                    fontWeight: 500,
                  }}
                >
                  🛰️ Satellite
                </button> */}

                {/* ─── Map Style Switcher ─────────────────────────────── */}
<div
  style={{
    display: 'flex',
    gap: '3px',
    padding: '3px',
    background: theme.bg,
    border: `1px solid ${theme.border}`,
    borderRadius: '7px',
  }}
>
  {/* STREET */}
  <button
    onClick={() => setMapStyle('street')}
    style={{
      padding: '5px 10px',
      background:
        mapStyle === 'street'
          ? theme.primary
          : 'transparent',
      color:
        mapStyle === 'street'
          ? '#fff'
          : theme.textSecondary,
      border: 'none',
      borderRadius: '5px',
      fontSize: '10px',
      fontWeight: 600,
    }}
  >
    🗺️ Street
  </button>

  {/* SATELLITE */}
  <button
    onClick={() => setMapStyle('satellite')}
    style={{
      padding: '5px 10px',
      background:
        mapStyle === 'satellite'
          ? theme.primary
          : 'transparent',
      color:
        mapStyle === 'satellite'
          ? '#fff'
          : theme.textSecondary,
      border: 'none',
      borderRadius: '5px',
      fontSize: '10px',
      fontWeight: 600,
    }}
  >
    🛰️ Satellite
  </button>

  {/* HYBRID */}
  <button
    onClick={() => setMapStyle('hybrid')}
    style={{
      padding: '5px 10px',
      background:
        mapStyle === 'hybrid'
          ? theme.primary
          : 'transparent',
      color:
        mapStyle === 'hybrid'
          ? '#fff'
          : theme.textSecondary,
      border: 'none',
      borderRadius: '5px',
      fontSize: '10px',
      fontWeight: 600,
    }}
  >
    🔀 Hybrid
  </button>
</div>


<button
  onClick={toggleRemovePointMode}
  style={{
    padding: '6px 12px',

    background:
      removePointMode
        ? theme.danger
        : theme.bg,

    color:
      removePointMode
        ? '#fff'
        : theme.textSecondary,

    border:
      `1px solid ${
        removePointMode
          ? theme.danger
          : theme.border
      }`,

    borderRadius: '6px',

    fontSize: '11px',

    fontWeight: 600,
  }}
>
  🗑️ Remove Point
</button>
                <button
                  onClick={startAdd}
                  style={{
                    padding: '6px 14px',
                    background: theme.primary,
                    color: '#fff',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '11px',
                    fontWeight: 600,
                  }}
                >
                  ✏️ Polygon
                </button>
                <button
                  onClick={startFreehand}
                  style={{
                    padding: '6px 14px',
                    background: theme.primary,
                    color: '#fff',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '11px',
                    fontWeight: 600,
                  }}
                >
                  🖌️ Brush
                </button>
                <button
                  onClick={startRadius}
                  style={{
                    padding: '6px 14px',
                    background: theme.primary,
                    color: '#fff',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '11px',
                    fontWeight: 600,
                  }}
                >
                  ⭕ Radius
                </button>
                <button
                  onClick={undo}
                  disabled={historyIndex <= 0}
                  style={{
                    padding: '6px 12px',
                    background: theme.bg,
                    color: historyIndex > 0 ? theme.text : theme.textMuted,
                    border: `1px solid ${theme.border}`,
                    borderRadius: '6px',
                    fontSize: '11px',
                    opacity: historyIndex > 0 ? 1 : 0.5,
                  }}
                >
                  ↩️ Undo
                </button>
                <button
                  onClick={redo}
                  disabled={historyIndex >= history.length - 1}
                  style={{
                    padding: '6px 12px',
                    background: theme.bg,
                    color: historyIndex < history.length - 1 ? theme.text : theme.textMuted,
                    border: `1px solid ${theme.border}`,
                    borderRadius: '6px',
                    fontSize: '11px',
                    opacity: historyIndex < history.length - 1 ? 1 : 0.5,
                  }}
                >
                  ↪️ Redo
                </button>
                {mode !== 'view' && (
                  <button
                    onClick={cancelDraw}
                    style={{
                      padding: '6px 12px',
                      background: theme.danger,
                      color: '#fff',
                      border: 'none',
                      borderRadius: '6px',
                      fontSize: '11px',
                      fontWeight: 500,
                    }}
                  >
                    ✕ Cancel
                  </button>
                )}
              </div>
              {/* Drawing form */}
              {mode !== 'view' && (
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap', marginTop: '6px' }}>
                  <input
                    value={formName}
                    onChange={e => setFormName(e.target.value)}
                    placeholder="Zone name (auto-filled from address)..."
                    style={{
                      flex: 1,
                      padding: '6px 10px',
                      background: theme.bg,
                      border: `1px solid ${theme.border}`,
                      borderRadius: '6px',
                      fontSize: '12px',
                      color: theme.text,
                      minWidth: '120px',
                    }}
                  />
                  <div style={{ display: 'flex', gap: '4px', background: theme.bg, borderRadius: '6px', border: `1px solid ${theme.border}`, padding: '2px' }}>
                    <button
                      onClick={() => setFormType('allowed')}
                      style={{
                        padding: '4px 10px',
                        borderRadius: '4px',
                        fontSize: '11px',
                        fontWeight: 500,
                        background: formType === 'allowed' ? theme.success : 'transparent',
                        color: formType === 'allowed' ? '#fff' : theme.textSecondary,
                        border: 'none',
                      }}
                    >
                      Allowed
                    </button>
                    <button
                      onClick={() => setFormType('blacklisted')}
                      style={{
                        padding: '4px 10px',
                        borderRadius: '4px',
                        fontSize: '11px',
                        fontWeight: 500,
                        background: formType === 'blacklisted' ? theme.danger : 'transparent',
                        color: formType === 'blacklisted' ? '#fff' : theme.textSecondary,
                        border: 'none',
                      }}
                    >
                      Blacklisted
                    </button>
                  </div>
                  <button
                    onClick={handleSave}
                    disabled={saving}
                    style={{
                      padding: '6px 16px',
                      background: theme.primary,
                      color: '#fff',
                      border: 'none',
                      borderRadius: '6px',
                      fontSize: '11px',
                      fontWeight: 600,
                    }}
                  >
                    {saving ? 'Saving...' : '💾 Save'}
                  </button>
                </div>
              )}
            </div>

            {/* Map container */}
            <div ref={mapRef} style={{ flex: 1, minHeight: '300px', background: theme.bg, position: 'relative' }}>
              {!mapsReady && (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <SpinnerInline />
                  <p style={{ fontSize: '12px', color: theme.textSecondary, marginTop: '8px' }}>Loading map...</p>
                </div>
              )}
            </div>

            {/* Area stats */}
            {areaInfo.area !== null && (
              <div style={{
                padding: '8px 14px',
                borderTop: `1px solid ${theme.border}`,
                background: theme.surface,
                fontSize: '12px',
                color: theme.textSecondary,
                display: 'flex',
                gap: '16px',
                flexWrap: 'wrap',
              }}>
                <span>📍 <strong>{areaInfo.points}</strong> points</span>
                <span>📐 Area: <strong>{areaInfo.area.toFixed(2)} km²</strong></span>
                <span>📏 Perimeter: <strong>{areaInfo.perimeter.toFixed(2)} km</strong></span>
              </div>
            )}
          </div>
        </div>

        {/* Right Panel: Zones List */}
        <div style={{ flex: 1, minWidth: '320px', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <div style={{
            background: theme.surface,
            border: `1px solid ${theme.border}`,
            borderRadius: '12px',
            padding: '16px',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            overflow: 'hidden',
          }}>
            <div style={{ display: 'flex', gap: '12px', marginBottom: '14px', flexShrink: 0 }}>
              <input
                type="text"
                placeholder="Search zones by name..."
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                style={{
                  flex: 1,
                  padding: '9px 12px',
                  background: theme.bg,
                  border: `1px solid ${theme.border}`,
                  borderRadius: '8px',
                  fontSize: '12px',
                  color: theme.text,
                }}
              />
              <button
                onClick={startAdd}
                style={{
                  padding: '9px 18px',
                  background: theme.primary,
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '12px',
                  fontWeight: 600,
                  whiteSpace: 'nowrap',
                }}
              >
                + Add Zone
              </button>
            </div>


            {/* ─── Selected Parent City ─────────────────────────── */}
{/* ─── Search Area Inside Selected City ───────────────────── */}
{selectedCity && (

  <div
    style={{
      position: 'relative',
      marginTop: '8px',
      marginBottom: '8px'
    }}
  >

    <div
      style={{
        fontSize: '10px',
        fontWeight: 600,
        color: theme.textMuted,
        marginBottom: '5px'
      }}
    >
      SEARCH DELIVERY AREA INSIDE {selectedCity.name.toUpperCase()}
    </div>


    <input

      type="text"

      value={areaQuery}

      placeholder={
        `Search Morar, Thatipur, Hazira, City Centre...`
      }

      onChange={(e) => {

        const value = e.target.value;

        setAreaQuery(value);

        setShowAreaResults(true);


        if (areaSearchTimer.current) {

          clearTimeout(
            areaSearchTimer.current
          );

        }


        if (value.trim().length >= 2) {

          areaSearchTimer.current =
            setTimeout(async () => {

              const results =
                await searchAreaInsideCity(
                  value
                );

              setAreaResults(results);

            }, 500);

        } else {

          setAreaResults([]);

        }

      }}

      onFocus={() => {

        if (areaResults.length) {

          setShowAreaResults(true);

        }

      }}

      style={{
        width: '100%',

        padding: '9px 11px',

        background: theme.bg,

        color: theme.text,

        border:
          `1px solid ${theme.border}`,

        borderRadius: '6px',

        fontSize: '12px'
      }}

    />
{/* ─── Selected Areas List ─── */}
{selectedAreas.length > 0 && (
  <div style={{ marginTop: '10px', marginBottom: '8px' }}>
    <div style={{
      fontSize: '10px',
      fontWeight: 600,
      color: theme.textMuted,
      marginBottom: '6px',
      textTransform: 'uppercase',
      letterSpacing: '0.3px'
    }}>
      Selected Areas ({selectedAreas.length}) — Click Allow or Blacklist
    </div>
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
      {selectedAreas.map((area, idx) => (
        <div
          key={area.place_id || idx}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            background: theme.bg,
            border: `1px solid ${
              area.type === 'allowed' ? theme.success :
              area.type === 'blacklisted' ? theme.danger :
              '#8b5cf6'
            }`,
            borderRadius: '6px',
            padding: '4px 8px',
            fontSize: '11px',
            fontWeight: 500,
          }}
        >
          <span style={{ color: theme.text }}>
            {area.name}
          </span>
          
          {area.type === 'pending' && (
            <span style={{ fontSize: '9px', color: theme.textMuted }}>(pending)</span>
          )}

          {/* ✅ Allow Button */}
          <button
            onClick={() => updateSelectedAreaType(idx, 'allowed')}
            disabled={area.type === 'allowed' || saving}
            style={{
              padding: '2px 8px',
              background: area.type === 'allowed' ? theme.success : 'transparent',
              color: area.type === 'allowed' ? '#fff' : theme.success,
              border: `1px solid ${theme.success}`,
              borderRadius: '4px',
              fontSize: '9px',
              fontWeight: 700,
              cursor: 'pointer',
              opacity: area.type === 'allowed' ? 1 : 0.7,
            }}
          >
            ✅ Allow
          </button>

          {/* 🚫 Blacklist Button */}
          <button
            onClick={() => updateSelectedAreaType(idx, 'blacklisted')}
            disabled={area.type === 'blacklisted' || saving}
            style={{
              padding: '2px 8px',
              background: area.type === 'blacklisted' ? theme.danger : 'transparent',
              color: area.type === 'blacklisted' ? '#fff' : theme.danger,
              border: `1px solid ${theme.danger}`,
              borderRadius: '4px',
              fontSize: '9px',
              fontWeight: 700,
              cursor: 'pointer',
              opacity: area.type === 'blacklisted' ? 1 : 0.7,
            }}
          >
            🚫 Blacklist
          </button>

          {/* ✕ Remove Button */}
          <button
            onClick={() => removeSelectedArea(idx)}
            style={{
              background: 'transparent',
              border: 'none',
              color: theme.textMuted,
              fontSize: '12px',
              cursor: 'pointer',
              padding: '0 2px',
            }}
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  </div>
)}

    {areaSearching && (

      <div
        style={{
          position: 'absolute',
          right: '10px',
          top: '31px',
          fontSize: '10px',
          color: theme.textMuted
        }}
      >
        Searching...
      </div>

    )}


   {showAreaResults && areaResults.length > 0 && (
  <div style={{
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    marginTop: '4px',
    background: theme.surface,
    border: `1px solid ${theme.border}`,
    borderRadius: '7px',
    boxShadow: '0 5px 18px rgba(0,0,0,0.18)',
    maxHeight: '260px',
    overflowY: 'auto',
    zIndex: 5000
  }}>
    {areaResults.map((result, index) => (
      <div
        key={result.place_id || index}
        style={{
          padding: '9px 10px',
          borderBottom: `1px solid ${theme.border}`
        }}
      >
        <div style={{
          fontSize: '12px',
          fontWeight: 600,
          color: theme.text
        }}>
          📍 {result.name}
        </div>
        <div style={{
          fontSize: '9px',
          color: theme.textMuted,
          marginTop: '2px'
        }}>
          {result.display}
        </div>

        <div style={{ display: 'flex', gap: '6px', marginTop: '6px', flexWrap: 'wrap' }}>
          {/* 👁 Preview Button – pehle jaisa hi */}
          <button
            onMouseDown={(e) => {
              e.preventDefault();
              previewArea(result);
            }}
            style={{
              padding: '4px 9px',
              background: theme.warning,
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              fontSize: '10px',
              fontWeight: 600,
              cursor: 'pointer'
            }}
          >
            👁 Preview
          </button>

          {/* ➕ SELECT Button – naya */}
          <button
            onMouseDown={(e) => {
              e.preventDefault();
              addAreaToBatch(result);   // ye function pehle se exist karta hai
              setShowAreaResults(false);
            }}
            style={{
              padding: '4px 12px',
              background: '#8b5cf6',   // Purple color
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              fontSize: '10px',
              fontWeight: 700,
              cursor: 'pointer'
            }}
          >
            ➕ Select
          </button>
        </div>
      </div>
    ))}
  </div>
)}
  </div>

)}
            <div style={{
              display: 'flex',
              gap: '8px',
              borderBottom: `1px solid ${theme.border}`,
              paddingBottom: '12px',
              flexWrap: 'wrap',
              flexShrink: 0,
            }}>
              {[
                { id: 'all', label: 'All Zones', count: stats.total },
                { id: 'allowed', label: 'Allowed', count: stats.allowed },
                { id: 'blacklisted', label: 'Blacklisted', count: stats.blacklisted },
                { id: 'active', label: 'Active Only', count: stats.active },
              ].map(tab => (
                <button
                  key={tab.id}
                  onClick={() => setFilter(tab.id)}
                  style={{
                    padding: '7px 16px',
                    background: filter === tab.id ? theme.primary : 'transparent',
                    color: filter === tab.id ? '#fff' : theme.textSecondary,
                    border: filter === tab.id ? 'none' : `1px solid ${theme.border}`,
                    borderRadius: '8px',
                    fontSize: '12px',
                    fontWeight: 500,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                  }}
                >
                  {tab.label} <span style={{ fontSize: '11px', opacity: 0.7 }}>({tab.count})</span>
                </button>
              ))}
            </div>

            <div style={{ flex: 1, overflowY: 'auto', marginTop: '14px', paddingRight: '4px' }}>
              {loading ? (
                <div style={{ textAlign: 'center', padding: '40px' }}><SpinnerInline /></div>
              ) : filteredZones.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '48px 20px', color: theme.textSecondary }}>
                  <p style={{ fontSize: '13px', marginBottom: '4px' }}>No zones found</p>
                  <p style={{ fontSize: '11px' }}>Adjust filters or add a new zone</p>
                </div>
              ) : (
                <>
                  <div style={{ fontSize: '11px', fontWeight: 600, color: theme.textSecondary, marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    {filteredZones.length} Zone{filteredZones.length !== 1 ? 's' : ''}
                  </div>
                  {filteredZones.map(zone => (
                    <div
                      key={zone.id}
                      style={{
                        background: theme.surface,
                        border: `1px solid ${theme.border}`,
                        borderRadius: '10px',
                        padding: '12px 14px',
                        marginBottom: '10px',
                        cursor: 'pointer',
                        borderLeft: `3px solid ${zone.zone_type === 'allowed' ? theme.success : theme.danger}`,
                      }}
                      onClick={() => focusOnZone(zone.id)}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                        <div>
                          <h3 style={{ fontSize: '14px', fontWeight: 600, color: theme.text, margin: 0, marginBottom: '4px' }}>
                            {zone.name}
                          </h3>
                          <div style={{ fontSize: '11px', color: theme.textSecondary }}>
                            {zone.polygon?.length || 0} boundary points
                          </div>
                        </div>
                        <button
                          onClick={(e) => { e.stopPropagation(); handleDelete(zone); }}
                          style={{
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            fontSize: '12px',
                            color: theme.textMuted,
                            padding: '4px 8px',
                            borderRadius: '4px',
                          }}
                          onMouseEnter={(e) => e.target.style.color = theme.danger}
                          onMouseLeave={(e) => e.target.style.color = theme.textMuted}
                        >
                          Delete
                        </button>
                      </div>

                      <div style={{ display: 'flex', gap: '8px', marginBottom: '12px', flexWrap: 'wrap' }}>
                        <span style={{
                          padding: '4px 10px',
                          borderRadius: '6px',
                          fontSize: '10px',
                          fontWeight: 600,
                          background: zone.zone_type === 'allowed' ? theme.successLight : theme.dangerLight,
                          color: zone.zone_type === 'allowed' ? theme.success : theme.danger,
                        }}>
                          {zone.zone_type === 'allowed' ? '✅ Allowed' : '🚫 Blacklisted'}
                        </span>
                        <span style={{
                          padding: '4px 10px',
                          borderRadius: '6px',
                          fontSize: '10px',
                          fontWeight: 600,
                          background: String(zone.status) === '1' ? theme.successLight : theme.warningLight,
                          color: String(zone.status) === '1' ? theme.success : theme.warning,
                        }}>
                          {String(zone.status) === '1' ? '🟢 Active' : '🔴 Inactive'}
                        </span>
                      </div>

                      <div style={{ display: 'flex', gap: '8px', borderTop: `1px solid ${theme.border}`, paddingTop: '10px', marginTop: '2px' }}>
                        <button
                          onClick={(e) => { e.stopPropagation(); toggleStatus(zone); }}
                          style={{
                            flex: 1,
                            padding: '6px 12px',
                            background: theme.primaryLight,
                            color: theme.primary,
                            border: 'none',
                            borderRadius: '6px',
                            fontSize: '11px',
                            fontWeight: 500,
                          }}
                        >
                          {String(zone.status) === '1' ? 'Deactivate' : 'Activate'}
                        </button>
                        <button
                          onClick={(e) => { e.stopPropagation(); toggleType(zone); }}
                          style={{
                            flex: 1,
                            padding: '6px 12px',
                            background: theme.primaryLight,
                            color: theme.primary,
                            border: 'none',
                            borderRadius: '6px',
                            fontSize: '11px',
                            fontWeight: 500,
                          }}
                        >
                          Toggle Type
                        </button>
                        <button
                          onClick={(e) => { e.stopPropagation(); startEdit(zone); }}
                          style={{
                            flex: 1,
                            padding: '6px 12px',
                            background: theme.primaryLight,
                            color: theme.primary,
                            border: 'none',
                            borderRadius: '6px',
                            fontSize: '11px',
                            fontWeight: 500,
                          }}
                        >
                          ✏️ Edit
                        </button>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}